import { render, staticRenderFns } from "./LeadsInformation.vue?vue&type=template&id=4bdec265&scoped=true&"
import script from "./LeadsInformation.vue?vue&type=script&lang=ts&"
export * from "./LeadsInformation.vue?vue&type=script&lang=ts&"
import style0 from "./LeadsInformation.vue?vue&type=style&index=0&id=4bdec265&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdec265",
  null
  
)

export default component.exports